import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { icons } from '../icons';

export default class PhotoMarker extends Component {

    componentDidMount() {

        
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }


    setBoundedPhoto() {
        let boundedPhotos = [];
        let boundedTours = [];
        let boundedLandmarks = [];
        let photoArray = [];

        if (this.props.points.list && this.props.points.list.length) {

            let mapObject = this.props.map;

            this.props.points.list.forEach(function (point, i) {
                point.images.forEach(function (photo) {
                    photoArray.push({
                        ...photo,
                        point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}
                    });

                    if (mapObject.getBounds().contains({lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)})) {
                        photo.point = {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)};
                        boundedPhotos.push(photo);
                    }
                });


            });


            this.boundedObjects = {
                photos: {list: boundedPhotos, count: 5},
                tours: {list: boundedTours},
                landmarks: {list: boundedLandmarks, count: 3}

            };

        }

        return {
            photos: {list: boundedPhotos, count: 5},
            tours: {list: boundedTours},
            landmarks: {list: boundedLandmarks, count: 3}

        };
    }

    selectMapPhoto() {
        this.props.actions.selectMapPhoto(this.props.photo, this.props.index);
        this.props.actions.setBoundedObjects(this.setBoundedPhoto());
    }

    render () {
        let photo = this.props.photo;

        if ((photo.quality==3 && this.props.zoom>=8) || (photo.quality==2 && this.props.zoom>=16)) {
            photo.good = true;
            photo.size = 'map30';
        } else {
            photo.size = 'map15';
        }

        return (
            <div className={"map__photo " + "map__photo_" + ((photo.good)?'good':'normal') } onClick={this.selectMapPhoto.bind(this)}>
                <div data-id={photo.id} className={"map__thumbnail "+ "map__thumbnail_" + ((photo.good)?'good':'normal')} style={{backgroundImage: ((photo.thumbnails[photo.size])?'url('+photo.thumbnails[photo.size].url+')':'')}}>
                   
                </div>
                {((photo.thumbnails && photo.thumbnails.map200)) &&
                    <div className={"map__thumbnail_large"} data-id={photo.id} style={{backgroundImage: ((photo.thumbnails.map200)?'url('+photo.thumbnails.map200.url+')':'')}}></div>
                }

            </div>



        );
    }
};



// WEBPACK FOOTER //
// ./src/common/components/map/PhotoMarker.js